module.exports = __webpack_public_path__ + "static/media/apifmgraphic.e877afb0.png";